import { defineStore } from 'pinia';
import {
    ROLE_ID_ADMIN,
    ROLE_ID_PH,
    ROLE_ID_ADMIN_WHOLESALER,
    ROLE_ID_PH_REG,
    ROLE_ID_ADMIN_ROOT
} from '@/hooks/UserHooks';
import type { IUser } from '@/models/UserModel';
import type { ILoginResponse } from '@/models/AuthModel';

interface IUserStore {
    userInfo: IUser | null
    isAdmin: boolean
    isAdminColian: boolean
    isPh: boolean
    isPhReg: boolean
    isAdminWholesaler: boolean
}

export const useUserStore = defineStore('useUserStore', {
    state: (): IUserStore => ({
        userInfo: null,
        isAdmin: false,
        isAdminColian: false,
        isPh: false,
        isPhReg: false,
        isAdminWholesaler: false,
    }),
    actions: {
        setUserInfo (userInfoValue: IUser | null) {
            this.userInfo = userInfoValue;

            if (userInfoValue?.role === ROLE_ID_ADMIN_ROOT) {
                this.isAdmin = true;
            }
            if (userInfoValue?.role === ROLE_ID_ADMIN) {
                this.isAdminColian = true;
            }
            if (userInfoValue?.role === ROLE_ID_PH) {
                this.isPh = true;
            }
            if (userInfoValue?.role === ROLE_ID_ADMIN_WHOLESALER) {
                this.isAdminWholesaler = true;
            }
            if (userInfoValue?.role === ROLE_ID_PH_REG) {
                this.isPhReg = true;
            }
        },
        loginUser (payload: ILoginResponse) {
            localStorage.setItem('accessToken', payload.token);
            localStorage.setItem('tokenType', payload.token_type);
        },
        logoutUser () {
            localStorage.removeItem('accessToken');
            localStorage.removeItem('tokenType');

            this.userInfo = null;
            this.isAdmin = false;
            this.isAdminColian = false;
            this.isPh = false;
            this.isAdminWholesaler = false;
            this.isPhReg = false;
        },
    },
});
